<template>
  <div class="app-layout">
    <main id="main">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout',
}
</script>
